/**
 * Extracts a human-readable message from an Axios/Feathers API error.
 * Falls back to the provided fallback string if no message can be determined.
 */
export function extractApiErrorMessage(error: unknown, fallback: string): string {
  if (error && typeof error === 'object') {
    const err = error as Record<string, unknown>

    // Axios error with Feathers response body: { message, className, code }
    const data = err['response'] && typeof err['response'] === 'object'
      ? (err['response'] as Record<string, unknown>)['data']
      : null

    if (data && typeof data === 'object') {
      const msg = (data as Record<string, unknown>)['message']
      if (typeof msg === 'string' && msg.trim()) return msg.trim()
    }

    // Direct error message (e.g. thrown manually)
    if (typeof err['message'] === 'string' && err['message'].trim()) {
      return err['message'].trim()
    }
  }
  return fallback
}

/** Extracts a stable application error code from Axios or direct Feathers errors. */
export function extractApiErrorCode(error: unknown): string | null {
  if (!error || typeof error !== 'object') return null
  const direct = error as {
    data?: { code?: unknown }
    response?: { data?: { code?: unknown; data?: { code?: unknown } } }
  }
  const code = direct.response?.data?.data?.code
    ?? direct.data?.code
    ?? direct.response?.data?.code
  return typeof code === 'string' && code.trim() ? code.trim() : null
}
